import { missingWidget } from '../utils.js';

export default function youtubeVideo() {
  const widgetName = 'videoWidget';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof videoWidgetOpts === 'undefined' ? null : videoWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const addVideoTag = true;
  const tagText = 'Watch';

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    autoPlayVideo: false,
    loopVideo: true, // autoPlayVideo must be enabled
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1) {
        if (addVideoTag) {
          $('#videoSection').append(`<div class="video-tag">${tagText}</div`);
        }
      } else {
        $('#videoSection').remove();
        missingWidget(widgetName);
      }
    },
  });
}
